import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'
import { AddGroupFormSchema, transformToApiRequest, type AddGroupFormData } from '../addGroup/schema'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

// editGroup reuses the AddGroupFormSchema (carrying the groupNumber business key
// for upsert), exactly like editRole reuses AddRoleFormSchema.
export const EditGroupFormSchema = AddGroupFormSchema
export type EditGroupFormData = AddGroupFormData

export { transformToApiRequest }
